import React from 'react';
import {
    Box,
    Typography,
    Avatar,
    Skeleton,
} from '@mui/material';
import { useSelector } from 'react-redux';

const LeaderboardCard = ({ data = [], loading = false }) => {
  const userData = useSelector((state) => state.userData.userData)

    if (loading) {
        return (
            <Box sx={{ backgroundColor: '#f15b5b', color: '#fff', borderRadius: '16px', p: 2, maxWidth: 300, mx: 'auto', textAlign: 'center' }}>
                <Typography variant="h6" mb={2}>Leaderboard</Typography>
                <Skeleton variant="circular" width={60} height={60} sx={{ mx: 'auto' }} />
                <Skeleton variant="text" width="60%" sx={{ mx: 'auto', mt: 1 }} />
                <Skeleton variant="rectangular" height={40} sx={{ mt: 2 }} />
            </Box>
        );
    }

    const topThree = data.filter(user => user.rank <= 3).sort((a, b) => a.rank - b.rank);
    const others = data.filter(user => user.rank > 3).sort((a, b) => a.rank - b.rank);

    const podiumConfig = {
        1: { position: { left: '50%', transform: 'translateX(-50%)', top: '20px' }, avatarSize: 60, scoreHeight: 80, fontSize: '40px' },
        2: { position: { left: '10px', top: '60px' }, avatarSize: 50, scoreHeight: 60, fontSize: '32px' },
        3: { position: { right: '10px', top: '60px' }, avatarSize: 50, scoreHeight: 60, fontSize: '32px' }
    };

    const renderTopUser = (user) => {
        const config = podiumConfig[user.rank];
        const isWinner = user.rank === 1;

        return (
            <Box key={user.user_id} sx={{ position: 'absolute', textAlign: 'center', ...config.position }}>
                <Box sx={{ position: 'relative', mb: 1 }}>
                    <Avatar
                        src={user.avatar_url}
                        alt={user.stage_name}
                        sx={{
                            width: config.avatarSize,
                            height: config.avatarSize,
                            mx: 'auto',
                            border: '3px solid rgba(255,255,255,0.3)',
                        }}
                    />
                    <Box
                        sx={{
                            position: 'absolute',
                            top: -8,
                            right: 15,
                            backgroundColor: '#2d5aa0',
                            width: 22,
                            height: 22,
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '12px',
                            fontWeight: 'bold',
                            color: '#fff',
                        }}
                    >
                        {user.rank}
                    </Box>
                </Box>
                <Typography variant="body2" sx={{ fontSize: '12px', mb: 0.5 }}>
                    {user.stage_name}
                </Typography>
                <Typography variant="caption" sx={{ fontSize: '10px', opacity: 0.8 }}>
                    {userData?.id == user?.user_id ? 'Your Rank': user.rank === 1 ? '1st' : `${user.rank}${user.rank === 2 ? 'nd' : 'rd'}`}
                </Typography>
                <Box
                    sx={{
                        mt: 1,
                        bgcolor: isWinner ? '#d94444' : 'rgba(255,255,255,0.2)',
                        borderRadius: '8px',
                        minHeight: config.scoreHeight,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Typography variant="h3" sx={{ fontWeight: 'bold', fontSize: config.fontSize }}>
                        {user.credit_score}
                    </Typography>
                </Box>
            </Box>
        );
    };

    return (
        <Box
            sx={{
                backgroundColor: '#f15b5b',
                color: '#fff',
                borderRadius: '16px',
                p: 2.5,
                // maxWidth: 320,
                // mx: 'auto',
                textAlign: 'center',
                fontFamily: 'Poppins, sans-serif',
            }}
        >
            <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '18px' }}>
                Leaderboard
            </Typography>

            {/* Top 3 Users Podium */}
            <Box sx={{ position: 'relative', mb: 4, height: '200px' }}>
                {topThree.map(renderTopUser)}
            </Box>

            {/* Rest of users list */}
            {others.length === 0 ? (
                <Box sx={{ bgcolor: '#fff', color: '#000', borderRadius: '16px', p: 1, maxHeight: '200px', overflowY: 'auto', my: 1 }}>
                    <Typography variant="body2" textAlign="center" color="gray">
                        No additional users
                    </Typography>
                </Box>
            ) : (
                others.map((user, index) => (
                    <Box key={user.user_id} sx={{ bgcolor: '#fff', color: '#000', borderRadius: '16px', p: 1, maxHeight: '200px', overflowY: 'auto', my: 1 }}>
                        <Box

                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                px: 1,
                            }}
                        >
                            <Avatar
                                src={user.avatar_url}
                                alt={user.stage_name}
                                sx={{
                                    width: 45,
                                    height: 45,
                                    border: '3px solid rgba(255,255,255,0.3)',
                                }}
                            />
                            <Typography sx={{ fontWeight: 500, fontSize: '14px', color: '#333', marginLeft: 2 }}>
                                {user.stage_name}
                            </Typography>
                        </Box>
                    </Box>
                ))
            )}
        </Box>
    );
};

export default LeaderboardCard;